export enum EModeleCompteur {

    ApexP3 = 1,
    ApexZ3 = 2,
    ApexZ50 = 3,
    Aerotrak = 4,
    ATI = 5,
    LASAIR3 = 6
}